import axios from '@/api/axios'
export default axios